import React from "react";

const FormErrorMessage = ({ message }) => (
  <span className="formErrorMessage">
    {message || "One or more fields have an error. Please check and try again."}
  </span>
);
export default FormErrorMessage;
